<template>
	<div class="layout-footer">
    <img class="center" src="../public/assets/layout/images/logo-coface-RVB.png" alt="logo-coface">
	</div>
</template>

<script>
	export default {
		name: "AppFooter"
	}
</script>

<style scoped>

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 3.5em;
}

</style>